<script>

    import { TweenMax, TimelineMax, Power2 } from 'gsap';

    export default {

        name: 'HomeAnimation',

        data() {
            return {
                count: 80,
                angle: 0,
                scaleBg: 2,
                scaleWh: 1.7,
                indexBg: 0,
                bgPath: '',
                fullWidth: 0,
                fullHeight: 0,
                rotationWh: -30,
                rotationBg: 30,
                maxScale: 1,
                bgWidth: 100,
                bgHeight: 100,
                whWidth: 100,
                whHeight: 100,
                bgW: 2480,
                bgH: 2480,
                maxSize: 0,
                minBgSize: 350,
                minWhSize: 350,
                whLeft: 10,
                whTop: 10,
                bgLeft: 10,
                bgTop: 10,
                posX: undefined,
                posY: undefined,
                oldX: undefined,
                oldY: undefined,
                testMsg: 'empty',
                window: {
                    width: 0,
                    height: 0,
                },
            };
        },

        mounted() {
            window.addEventListener('resize', this.handleWindowResize);
            this.handleWindowResize();

            this.indexBg = this.random(this.count);
            this.bgPath = '/storage/imageshome/' + this.padNumber(this.indexBg, 3) + '.jpg';
            this.loadBg();
            this.handleResize();
            this.hasTouchEnabled = 'ontouchstart' in document.documentElement;

            window.addEventListener('resize', this.handleResize);
            window.addEventListener('mousemove', this.handleMove);
            window.addEventListener('mouseover', this.handleMove);

            let self = this;
            // if (window.DeviceOrientationEvent) {
            //     window.addEventListener('deviceorientation', function (event) {
            //         self.gyro(event.beta, event.gamma);
            //     }, true);
            // } else if (window.DeviceMotionEvent) {
            //     window.addEventListener('devicemotion', function (event) {
            //         self.gyro(event.acceleration.x * 2, event.acceleration.y * 2);
            //     }, true);
            // } else {
            //     window.addEventListener('MozOrientation', function (event) {
            //         self.gyro(orientation.x * 50, orientation.y * 50);
            //     }, true);
            // }
            if (this.hasTouchEnabled) {
                this.startRandomMovements();
            }

            TweenMax.set(this.$refs.animation, { opacity: 1 });

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleWindowResize);
            window.removeEventListener('mousemove', this.handleMove);
            window.removeEventListener('mouseover', this.handleMove);
            this.mainHeader.classList.remove('is-mouse-over');
        },
        methods: {
            handleWindowResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                this.getNavPosition();
            },
            getNavPosition() {
                const mainNavEl = document.querySelector('.nav-wrap');
                this.mainHeader = document.querySelector('.main-header');
                this.mainNav = {
                    bottom: mainNavEl.offsetTop + mainNavEl.clientHeight,
                    right: mainNavEl.offsetLeft + mainNavEl.clientWidth,
                };
            },

            startRandomMovements() {
                const randomDir = (Math.random() > 0.5 ? 1 : -1);
                const randomScaleWh = (Math.random() * (this.maxScale - 0.6)) + 0.2;
                const randomRotationWh = Math.random() * 180 * randomDir;
                const randomScaleBg = (Math.random() * (this.maxScale - 0.7)) + 0.7;
                const randomRotationBg = Math.random() * 180 * randomDir * -1;

                const duration = Math.random() * 2 + 2;

                const tl = new TimelineMax({
                    onComplete: this.startRandomMovements,
                })
                tl.to(this.$refs.white, duration, { scale: randomScaleWh, rotation: randomRotationWh, ease: Power2.easeInOut }, 0);
                tl.to(this.$refs.bg, duration, { scale: randomScaleBg, rotation: randomRotationBg, ease: Power2.easeInOut }, 0);
            },

            padNumber(number, length) {
                let str = '' + number;
                while (str.length < length) {
                    str = '0' + str;
                }

                return str;
            },
            random(v) {
                return Math.floor(Math.random() * v) + 1;
            },
            loadBg() {
            },
            handleResize() {
                this.fullHeight = this.window.height;
                this.fullWidth = this.window.width;

                if (this.fullWidth < this.fullHeight) {
                    this.maxSize = 1.2 * this.fullWidth;
                } else {
                    this.maxSize = 1.2 * this.fullHeight;
                }

                this.centerX = this.fullWidth / 2;
                this.centerY = this.fullHeight / 2;

                this.posX = this.centerX;
                this.posY = this.centerY;
                this.oldX = this.centerX;
                this.oldY = this.centerY;

                this.maxScale = this.maxSize / 180;

                this.bgLeft = this.centerX - this.minBgSize / 2;
                this.bgTop = this.centerY - this.minBgSize / 2;

                this.whLeft = this.centerX - this.minWhSize / 2;
                this.whTop = this.centerY - this.minWhSize / 2;

                TweenMax.set(this.$refs.bg, { left: this.bgLeft, top: this.bgTop });
                TweenMax.set(this.$refs.white, { left: this.whLeft, top: this.whTop });

                this.updatePos();
            },
            handleMove(e) {
                this.posX = e.clientX;
                this.posY = e.clientY;

                if (this.oldX === undefined) {
                    this.oldX = this.posX;
                    this.oldY = this.posY;
                    this.rotationWh = 0;
                    this.rotationBg = 0;
                }

                this.rotationWh += this.posX - this.oldX;
                this.rotationBg -= this.posX - this.oldX;

                this.oldX = this.posX;
                this.oldY = this.posY;

                var val, val2;

                if (this.posY < this.centerY) {
                    val2 = (this.centerY - this.posY) / Math.abs(this.centerY) * (this.maxScale - 1.5) + 1.5;
                } else {
                    val2 = (1 - (this.posY - this.centerY) / Math.abs(this.centerY)) * 1.5;
                }

                if (this.posY < this.centerY) {
                    val = (Math.abs(this.posY) / Math.abs(this.centerY)) * 2.2;
                } else {
                    val = (this.posY - this.centerY) / Math.abs(this.centerY) * (this.maxScale - 2.2) + 2.2;
                }

                this.scaleWh = val;
                this.scaleBg = val2;

                this.updatePos();

                if (this.posY < this.mainNav.bottom * 1.4) {
                    this.mainHeader.classList.add('is-mouse-over');
                } else {
                    this.mainHeader.classList.remove('is-mouse-over');
                }
            },
            gyro(b, g) {
                if (b != null && g != null) {
                    this.posX = g;
                    this.posY = b;

                    //+
                    this.rotationWh = ((g + 90) / 180) * 360;
                    this.rotationBg = 360 - this.rotationWh;

                    if (b < 45) this.scaleWh = 1; else
                    if (b > 45) this.scaleWh = this.maxScale; else {
                        this.scaleWh = ((b + 45) / 90) * this.maxScale + 1;
                    }

                    this.scaleBg = this.maxScale - this.scaleWh + 1;
                    this.updatePos();
                }
            },
            updatePos() {
                this.bgWidth = this.minBgSize;
                this.bgHeight = this.minBgSize;

                this.whWidth = this.minBWhSize;
                this.whHeight = this.minWhSize;

                TweenMax.killAll();

                TweenMax.to(this.$refs.white, 0.8, { scale: this.scaleWh, rotation: this.rotationWh });
                TweenMax.to(this.$refs.bg, 0.8, { scale: this.scaleBg, rotation: this.rotationBg });
            },

        },

    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/HomeAnimation.vue